// extracted by mini-css-extract-plugin
export default {"message":"NotFound_message__2fcyQ"};